import { ForwardedRef, forwardRef } from "react";
import { tv } from "tailwind-variants";

const styles = tv({
  slots: {
    styledLabel:
      "inline-flex cursor-pointer items-start bg-inherit disabled:cursor-not-allowed disabled:bg-gray",
    styledInput:
      "m-0 mr-15 mt-[7px] inline-grid min-h-[16px] min-w-[16px] cursor-pointer appearance-none place-content-center rounded-sm border-[1px] border-[#00000025] bg-gradient-to-r from-white via-white to-gray-light before:check-box-before checked:bg-primary checked:bg-none checked:before:scale-100 disabled:cursor-not-allowed disabled:bg-gray disabled:before:shadow-sm disabled:checked:bg-gray-light",
  },
});
interface IProps {
  label?: string | JSX.Element;
  id?: string | null;
  name: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
}

const Checkbox = forwardRef(
  (
    { label, id = null, name, checked, onChange, disabled = false }: IProps,
    ref: ForwardedRef<HTMLInputElement | null>,
  ) => {
    const { styledLabel, styledInput } = styles();

    const renderLabelAndCheckbox = () => (
      <label className={styledLabel()}>
        {renderCheckbox()}
        {label}
      </label>
    );

    const renderCheckbox = () => (
      <input
        className={styledInput()}
        id={id || name}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        ref={ref}
      />
    );

    return !!label ? renderLabelAndCheckbox() : renderCheckbox();
  },
);

export default Checkbox;
